/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Recovery_RangeInputs */

const en_exp_recovery_range = /** @type {(inputs: Exp_Recovery_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Above 25 bpm: strong recovery, well-adapted cardiovascular system. 15-25 bpm: adequate recovery, typical for moderately trained athletes. Below 15 bpm: slow recovery, may indicate fatigue, dehydration, or room for aerobic base work.`)
};

const de_exp_recovery_range = /** @type {(inputs: Exp_Recovery_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Über 25 bpm: starke Erholung, fit. 15–25 bpm: gute Erholung, mäßig trainiert. Unter 15 bpm: langsam — kann auf Ermüdung, Dehydrierung oder Nachholbedarf bei der Grundlage hindeuten.`)
};

/**
* | output |
* | --- |
* | "Above 25 bpm: strong recovery, well-adapted cardiovascular system. 15-25 bpm: adequate recovery, typical for moderately trained athletes. Below 15 bpm: slow ..." |
*
* @param {Exp_Recovery_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_recovery_range = /** @type {((inputs?: Exp_Recovery_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Recovery_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_recovery_range(inputs)
	return de_exp_recovery_range(inputs)
});